//* ---------------------------------------
//共通実行処理
//-------------------------------------- */
import objectFitImages from 'object-fit-images';
import {
  headerNavFunc
} from "./common/_header";
import {
  footerFunc
} from "./common/_footer";
import {
  fadeInFunc
} from "./common/_common";
import {
  sliderFunc,
} from "./common/_slider";
import {
  hoverFunc,
  telLinkFunc,
  animeLinkFunc
} from "./common/_hoverFunc";
import {
  heightLine,
  heightLineSetFunc,
  heightLineFunc
} from './common/_heightLine';
import {
  buttonActionFunc,
  lagActionFunc
} from "./common/_buttonAction";
import {
  pageLinkAnimationFunc,
  pageMoveAnkerFunc,
} from './common/_pageLinkAnimation';
import {
  keyVisualMovie
} from './common/_keyVisualMovie';
//* ---------------------------------------
//各ページ実行処理
//-------------------------------------- */
import {
  idxFunc
} from "./pages/_index";
import {
  productsFunc
} from "./pages/_products";
import {
  buyFunc
} from "./pages/_buy";
import {
  contentsFunc,
  contentsYofukashiFunc
} from "./pages/_contents";
import {
  attentionFunc
} from "./pages/_attention";
import {
  topicsFunc
} from "./pages/_topics";
import {
  aboutFunc
} from "./pages/_about";
import {
  campaignFunc,
  ajaxFunc
} from "./pages/_campaign";
import {
  contactFunc
} from "./pages/_contact";
//* ---------------------------------------
//通常実行
//-------------------------------------- */
//オブジェクトフィット使用
objectFitImages();
let setTimer = null;
//* ----------------------------------------
//window実行
//--------------------------------------- */

////// ロード時
$(window).on('load', function () {

  //クリック処理
  headerNavFunc();
  topicsFunc();
  //topics
  fadeInFunc();
  buttonActionFunc();
  //トップページ
  idxFunc();
  sliderFunc();
  //下層ページ
  productsFunc();
  buyFunc();
  contentsFunc();
  attentionFunc();
  aboutFunc();
  campaignFunc();
  ajaxFunc();
  contactFunc();
  contentsYofukashiFunc();
  //高さ調整
  heightLine();
  heightLineSetFunc();
  //共通項目
  pageLinkAnimationFunc();
  pageMoveAnkerFunc();
  hoverFunc();
  animeLinkFunc();
  keyVisualMovie();
  footerFunc();
});

// リサイズ時
/*リサイズ後,200msで発火する設定*/
$(window).on('resize', function () {
  clearTimeout(setTimer);
  setTimer = setTimeout(() => {
    heightLineSetFunc();
    contentsYofukashiFunc();
  }, 200);
});

// スクロール時
$(window).on('scroll', function () {
  clearTimeout(setTimer);
  setTimer = setTimeout(() => {

  }, 200);
});
///* -----------------------------------------------
//ユーザーエージェント判別実行(uaFlag：1→スマホ&タブレット・2→IE・3→その他PC)
//----------------------------------------------- */
var uaFlag = 0;
if ((
    navigator.userAgent.indexOf('iPhone') > 0) ||
  (navigator.userAgent.indexOf('iPod') > 0) ||
  (navigator.userAgent.indexOf('iPad') > 0) ||
  (navigator.userAgent.indexOf('Android') > 0) ||
  (navigator.userAgent.indexOf('BlackBerry') > 0) ||
  (navigator.userAgent.indexOf('PlayBook') > 0) ||
  (navigator.userAgent.indexOf('Kindle') > 0) ||
  (navigator.userAgent.indexOf('Silk') > 0) ||
  (navigator.userAgent.indexOf('Windows Phone') > 0) ||
  (navigator.userAgent.indexOf('Nokia') > 0)
) {
  // スマホ・タブレット時の処理
  uaFlag = 1;
} else {
  // PC時の処理
  uaFlag = 3;
  lagActionFunc();
}
/* -----------------------------------------------
IEだけの時
----------------------------------------------- */
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {

}
